import { ERoutes } from 'shared/types/routes'

export const routesWithoutPrevPath: ERoutes[] = [
  ERoutes.Line,
  ERoutes.LiveEvents
]
